import IMask from "imask";
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { format, parse } from "date-fns";
import { FieldType } from "@ngx-formly/core";
import { FormControl } from "@angular/forms";
import { Subject } from "rxjs";

@Component({
    selector: "time-picker",
    templateUrl: "./time-picker.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimePickerComponent extends FieldType implements OnInit, OnDestroy {
    _unsubscribeAll = new Subject();

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.formControl.valueChanges.subscribe((value) => {
            if (value instanceof Date) {
                this.field.formControl.setValue(format(value, "HH:mm"));
            }
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get selectedTime() {
        return this.field.formControl.value;
    }

    get placeholder() {
        return this.field.templateOptions.placeholder;
    }

    get control() {
        return this.field.formControl as FormControl;
    }

    timeSet(event: any) {
        this.field.formControl.setValue(event);
    }

    public getInputMaskForTime() {
        let inputDateMomentFormat = "HH:mm";
        return {
            mask: Date,
            pattern: inputDateMomentFormat,
            format: function (date) {
                if (date instanceof Date) {
                    return format(date, inputDateMomentFormat);
                }
                return date;
            },
            parse: function (str) {
                if (str instanceof Date) {
                    return str;
                }
                return parse(str, inputDateMomentFormat, new Date());
            },
            lazy: false,
            blocks: {
                HH: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 23,
                },
                mm: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 59,
                },
            },
        };
    }
}
